import {keys} from 'ts-transformer-keys';
import {Condition} from '~/shared/src/utilities/condition';

export type Style = {
    key: string;
    className? : string;
    condition? : Condition;
    order? : number;
    style? : {
        [ attribute : string ] : string;
    };
};
export const styleProps = keys<Style>();
